/**
 * Profile Label Mappings
 * Provides human-readable labels for profile enum values
 */

export const genderLabels: Record<string, string> = {
  MALE: 'Masculino',
  FEMALE: 'Feminino',
};

export const educationLabels: Record<string, string> = {
  FUNDAMENTAL: 'Ensino Fundamental',
  MEDIO: 'Ensino Médio',
  SUPERIOR: 'Ensino Superior',
  POS_GRADUACAO: 'Pós-Graduação',
  MESTRADO: 'Mestrado',
  DOUTORADO: 'Doutorado',
};

export const economicLabels: Record<string, string> = {
  NO_INCOME: 'Sem rendimento',
  UP_TO_HALF_MW: 'Até ½ Salário Mínimo',
  ONE_TO_TWO_MW: '1 a 2 Salários Mínimos',
  TWO_TO_FIVE_MW: '2 a 5 Salários Mínimos',
  FIVE_TO_TEN_MW: '5 a 10 Salários Mínimos',
  TEN_TO_TWENTY_MW: '10 a 20 Salários Mínimos',
  ABOVE_TWENTY_MW: 'Acima de 20 Salários Mínimos',
};
